export type FeatureType = MyBrokerApi.DocumentFilter | "policyholders";

export interface Document extends Omit<MyBrokerApi.Document, "policyHolderId"> {
    policyholderId: number;
    secondaryDescription: string;
}

export interface DocumentPagination extends Omit<MyBrokerApi.DocumentPayload, "result"> {
    result: Document[];
}

export type DocumentsSortProperty = Paths.ApiDocument.Get.Parameters.SortProperty;
export type RelatedDocumentsSortProperty = Paths.ApiDocumentRelated$Id.Get.Parameters.SortProperty;
export type SearchDocumentsSortProperty = Paths.ApiDocumentSearch.Get.Parameters.SortProperty;

export interface SearchableDocument extends Document {
    formattedDate?: string;
    formattedTypeSize?: string;
}

export interface SignDocumentRequest extends Omit<MyBrokerApi.SignDocumentRequest, "signedOn"> {
    signedOn: Date;
}

export const getDocumentDescription = (name: string, origin: string): string => {
    if (!origin.includes("+")) {
        return `${name} - ${origin}`;
    }

    const index = origin.indexOf("+");
    const reference = origin.substring(index);
    const originName = origin.substring(0, index - 3);

    return `${name} (${reference}) - ${originName}`;
};
